export default class NewMeetingComment {
    content: string

    constructor(content: string) {
        this.content = content
    }
}
